var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "900" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "", sm: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _vm.items.length == 0 && _vm.inited
            ? _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$ct(
                                "no-tracking-numbers-found-for-this-product"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-scroll-view",
                {
                  attrs: { tag: "w-list" },
                  on: {
                    scroll: function ($event) {
                      return _vm.onScroll($event)
                    },
                  },
                },
                [
                  _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.$ct("tracking-number"))),
                      ]),
                      _c("w-list-item-text", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.$ct("stock-location"))),
                      ]),
                      _c("w-list-item-text", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.$ct("total-in-stock"))),
                      ]),
                      _c("w-list-item-text", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.$ct("valid-until"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(_vm.items, function (item) {
                    return _c(
                      "w-list-item",
                      {
                        key: item.TrackingNumber,
                        on: {
                          click: function ($event) {
                            return _vm.selectItem(item)
                          },
                        },
                      },
                      [
                        _c("w-list-item-text", [
                          _vm._v(_vm._s(item.TrackingNumber)),
                        ]),
                        _c("w-list-item-text", [
                          _vm._v(_vm._s(_vm.getLocationsText(item))),
                        ]),
                        _c("w-list-item-text", [
                          _vm._v(_vm._s(item.getTotalInStock())),
                        ]),
                        _c("w-list-item-text", [
                          _vm._v(_vm._s(item.getValidUntilString())),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }